import { ColumnDef } from "@tanstack/react-table";

import { Document } from "./schema";
import { DataTableColumnHeader } from "./data-table-column-header";

// import { Checkbox } from "@/components/ui/checkbox/checkbox";
import { Button } from "@/components/ui/button/button";
// import { UpdateRowModal } from "./update-row-modal";

export const columns: ColumnDef<Document>[] = [
  // {
  //   accessorKey: "id",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Index" />
  //   ),
  //   cell: ({ row }) => <div className="w-[80px]">{row.getValue("id")}</div>,
  //   enableSorting: false,
  //   enableHiding: false,
  // },
  // {
  //   id: "select",
  //   header: ({ table }) => (
  //     <Checkbox
  //       checked={
  //         table.getIsAllPageRowsSelected() ||
  //         (table.getIsSomePageRowsSelected() && "indeterminate")
  //       }
  //       onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
  //       aria-label="Select all"
  //       className="translate-y-[2px]"
  //     />
  //   ),
  //   cell: ({ row }) => (
  //     <Checkbox
  //       checked={row.getIsSelected()}
  //       onCheckedChange={(value) => row.toggleSelected(!!value)}
  //       aria-label="Select row"
  //       className="translate-y-[2px]"
  //     />
  //   ),
  //   enableSorting: false,
  //   enableHiding: false,
  // },
  {
    accessorKey: "doc",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Document Name" />
    ),
    cell: ({ row }) => <div className="truncate">{row.getValue("doc")}</div>,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "url",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="File" />
    ),
    cell: ({ row }) => (
      <div>
        <Button size="sm" variant="outline" asChild>
          <a target="_blank" href={row.getValue("url")}>
            File
          </a>
        </Button>
      </div>
    ),
    enableSorting: false,
    enableHiding: false,
  },

  // {
  //   id: "actions",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Actions" />
  //   ),
  //   cell: ({ row, table }) => <UpdateRowModal row={row} table={table} />,
  // },
];
